module.exports = require('./helpers/bundle-url').getBundleURL('7oW7R') + "logo-dark.eefe0b7f.svg";